import Paragraph from '@/components/renderers/Paragraph';
import Authors from '@/components/Authors';

export default function PostMeta({ date, people, type }) {
  const showDate = ['BLOG', 'WEBINAR'].includes(type) || !type;

  return (
    <div className="mx-auto">
      <div className="flex gap-3 items-center justify-center flex-wrap text-mid-gray leading-relaxed">
        <Authors people={people} />
      </div>
      {showDate && (
        <Paragraph className="text-sm md:text-base text-cornflower">
          {date}
        </Paragraph>
      )}
    </div>
  );
}
